var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18195 0.864805L2.89995 0.635472C3.57195 0.420805 4.29061 0.768139 4.57861 1.44681L5.15195 2.79881C5.40195 3.38747 5.26328 4.08014 4.80928 4.51081L3.54728 5.70947C3.62528 6.42681 3.86595 7.13281 4.26995 7.82747C4.65383 8.49959 5.16866 9.08786 5.78395 9.55747L7.30128 9.05081C7.87595 8.85947 8.50195 9.08014 8.85461 9.59814L9.67595 10.8048C10.0866 11.4075 10.0126 12.2381 9.50395 12.7488L8.95861 13.2961C8.41595 13.8408 7.64128 14.0388 6.92395 13.8148C5.23128 13.2868 3.67528 11.7195 2.25528 9.11281C0.833281 6.50214 0.331948 4.28614 0.749948 2.46747C0.925948 1.70214 1.47128 1.09214 2.18328 0.864805H2.18195Z",
    fill: "#725CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.628bb7c9ce873a57aec5565b06d22175.svg";
export { ForwardRef as ReactComponent };